import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import { NavigationTabsBuilder } from '../builder/NavigationTabs';
import BuilderSidebar from '../builder/BuilderSidebar';
import Model from '../builder/Model';
import Checkbox from '../builder/Checkbox';
import Layout from '../front/Layout.js';
import BuilderCanvas from '../builder/BuilderCanvas.js';
import StageFinalMessages, { useFinalPage } from '../games/StageFinalMessages.js';
import Tooltip from '../builder/Tooltip.js';
import Input from '../builder/Input.js';

const GameScoreBuilder = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ actual_state, setFinalCase ] = useFinalPage(stage?.final_messages);
	stage.display_status = stage?.display_status ?? 'success';

	const has_threshold = props?.has_threshold ?? false;
	const excludes = (has_threshold === false || parseInt(stage?.game_success_threshold ?? '0') > 0) ? props.exclude_cases : [...props.exclude_cases,'fail'];

	return (
		<>
			<BuilderSidebar onSave={props.saveStage}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				{(has_threshold) && (
					<article>
						<Model model={stage} change={change}>
							<Input
								name='game_success_threshold'
								_type='number'
								extra_contents={i18n("in points")}
								_class={{ size:40, first:true }}
								value={stage?.game_success_threshold ?? 0}
								label_props={{
									tooltip:<Tooltip position='bottom'>Specify the number of points that users must achieve as a minimum to consider their game a success. After indicating the minimum score, you can customize the screen that users will see depending on whether they have reached the minimum number of points or not.</Tooltip>,
								}}
							>Goal</Input>

							<Checkbox
								name="game_display_threshold"
							>Show progress bar</Checkbox>
						</Model>
					</article>
				)}

				<article class={(has_threshold) ? "gui_not_in_top_huge" : null}>
					<StageFinalMessages
						stage={stage}
						final_messages={stage.final_messages}
						fields={['color', 'image']}
						exclude={excludes}
						onOpen={(id) => {
							if(!id) return;
							setFinalCase(id);
						}}
						change={(v) => {
							change('final_messages', v)
						}}
					/>

					<Model model={stage} change={change}>
						<Checkbox
							name="hide_score_resumee"
						>Hide score summary</Checkbox>

						<Checkbox
							name="override_promo_styles"
							value={stage?.override_promo_styles ?? false}
							label_props={{
								tooltip:<Tooltip>Configure the game result screens with specific background colors for each outcome. For example, use a green background to show the game was completed successfully and a red background when it wasn't. Enable this option if you prefer not to use different colors based on the game's result and instead apply the promotion's general color scheme.</Tooltip>,
							}}
						>Apply the promotion's general colors</Checkbox>
					</Model>
				</article>
			</BuilderSidebar>

			<BuilderCanvas
				fit_to_window="content"
			>
				<Layout
					promo={props.promotion}
					is_builder={true}
					page="quiz"
					menus={props.promoModel.Custom__Menus}
					layout_extra_classes="is_new_game"
				>
					<div
						class="gui_withoutEvents"
						style={{ width:'100%', height:'100%' }}
					>
						{React.cloneElement(props.children, {
							actual_state,
						})}
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

export default injectIntl(GameScoreBuilder);